import { Component, Input, model } from '@angular/core';
import { BooleanInputComponent } from '@common/components/input/boolean-input/boolean-input.component';
import { CodelistInputComponent } from '@common/components/input/codelist-input/codelist-input.component';
import { DateInputComponent } from '@common/components/input/date-input/date-input.component';
import { DaterangeInputComponent } from '@common/components/input/daterange-input/daterange-input.component';
import { DatetimeInputComponent } from '@common/components/input/datetime-input/datetime-input.component';
import { FileInputComponent } from '@common/components/input/file-input/file-input.component';
import { NumberInputComponent } from '@common/components/input/number-input/number-input.component';
import { SelectInputComponent } from '@common/components/input/select-input/select-input.component';
import { TextInputComponent } from '@common/components/input/text-input/text-input.component';
import { TextareaInputComponent } from '@common/components/input/textarea-input/textarea-input.component';
import { InputConfig, InputType } from './input.type';

/**
 * General input component that handles all types of inputs.
 * @param value - The input value.
 * @param config - The input configuration.
 */
@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    imports: [
        TextInputComponent,
        NumberInputComponent,
        TextareaInputComponent,
        BooleanInputComponent,
        DateInputComponent,
        DatetimeInputComponent,
        DaterangeInputComponent,
        FileInputComponent,
        SelectInputComponent,
        CodelistInputComponent
    ]
})
export class InputComponent {
    value = model.required<any>();
    @Input() config: InputConfig;

    inputTypes = InputType;
}
